// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasShellContext, withIsInShell } from "@insite/client-framework/Components/IsInShell";
import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentUserIsGuest } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getReturnUrl } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import TextSeparator, { TextSeparatorPresentationProps } from "@store/Library/Components/Toolkit/TextSeparator";
import { signInProps } from "@store/Themes/common/props/signIn";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import React, { FC } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

type OwnProps = WidgetProps & HasShellContext;

type Props = ReturnType<typeof mapStateToProps> & OwnProps;

const mapStateToProps = (state: ApplicationState, props: OwnProps) => ({
    allowCreateAccount: state.context.settings.settingsCollection.accountSettings.allowCreateAccount,
    allowGuestCheckout:
        state.context.settings.settingsCollection.accountSettings.allowGuestCheckout && !getCurrentUserIsGuest(state),
    /* Starter Custom Code - Start */
    showGuestCheckout:
        (getReturnUrl(state) && getReturnUrl(state) === getPageLinkByPageType(state, "CheckoutShippingPage")?.url) ||
        props.shellContext.isEditing,
    /* Starter Custom Code - End */
});

export interface SignInStyles {
    container?: InjectableCss;
    grid?: GridContainerProps;
    signInGridItem?: GridItemProps;
    separatorGridItem?: GridItemProps;
    separator?: TextSeparatorPresentationProps;
    createAndGuestGridItem?: GridItemProps;
    spacerGridItem?: GridItemProps;
}

const signInStyles: SignInStyles = {
    grid: { gap: 0 },
    signInGridItem: { width: [12, 12, 4, 4, 4] },
    separatorGridItem: {
        width: [12, 12, 1, 1, 1],
        css: css`
            justify-content: center;
        `,
    },
    separator: {
        ...signInProps.separator,
        directionBreakpoint: "md",
    },
    createAndGuestGridItem: {
        width: [12, 12, 3, 3, 3],
        css: css`
            ${breakpoint("md")} {
                display: flex;
                align-items: stretch;
                height: auto;
            }
        `,
    },
};

const styles = signInStyles;

const SignInView: FC<Props> = ({ id, allowCreateAccount, allowGuestCheckout, showGuestCheckout }) => {
    return (
        <StyledWrapper {...styles.container}>
            <GridContainer {...styles.grid}>
                <GridItem {...styles.signInGridItem}>
                    <Zone contentId={id} zoneName="Left" />
                </GridItem>
                {allowCreateAccount && (
                    <>
                        <GridItem {...styles.separatorGridItem}>
                            <TextSeparator {...styles.separator}>{translate("OR")}</TextSeparator>
                        </GridItem>
                        <GridItem {...styles.createAndGuestGridItem}>
                            <Zone contentId={id} zoneName="Middle" />
                        </GridItem>
                    </>
                )}
                {allowGuestCheckout && showGuestCheckout && (
                    <>
                        <GridItem {...styles.separatorGridItem}>
                            <TextSeparator {...styles.separator}>{translate("OR")}</TextSeparator>
                        </GridItem>
                        <GridItem {...styles.createAndGuestGridItem}>
                            <Zone contentId={id} zoneName="Right" />
                        </GridItem>
                    </>
                )}
            </GridContainer>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: withIsInShell(connect(mapStateToProps)(SignInView)),
    definition: {
        allowedContexts: ["SignInPage"],
        group: "Sign In",
        icon: "table-layout",
    },
};

export default widgetModule;
